import React, { useState } from "react";
import { colors } from "../../../../../../themes/Colors";

const BranchCard = ({ branchName }) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      style={{
        width: "100%",
        // borderBottomStyle: "solid",
        // borderBottomWidth: 2,
        // borderColor: "#00000050",
        height: 150,

        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: 2,
      }}
    >
      <div
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
        style={{
          height: 130,
          width: "90%",
          //   borderStyle: "solid",
          borderRadius: 8,
          backgroundColor: colors.primaryOrange50,
          WebkitBoxShadow: hover
            ? "-2px 10px 20px -10px #00000050"
            : "0px 0px 0px 0px #00000050",
          display: "flex",
          overflow: "hidden",
          transition: "all 0.3s",
        }}
      >
        <div
          style={{
            height: "100%",
            width: "65%",
            // borderStyle: "solid",
            backgroundColor: colors.white,
          }}
        ></div>
        <div
          style={{
            height: "92%",
            width: "35%",
            borderStyle: "solid",
            borderWidth: 5,
            borderColor: hover ? colors.primaryOrange : colors.white,
            backgroundColor: hover ? null : colors.white,
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
            borderTopRightRadius: 10,
            borderBottomRightRadius: 10,
            transition: "all 0.3s",
          }}
        >
          {branchName}
        </div>
      </div>
    </div>
  );
};
export default BranchCard;
